import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class CustomFunctions {
  ifNaN(num1: number, num2: number): string {
    return !isNaN(+(num1 / num2 * 100).toFixed(0)) ? (num1 / num2 * 100).toFixed(0).toString() : '';
  }

  priceFormat(price: any): string {
    if(price || price === 0) {
      if (typeof price === 'number') {
        price = price.toString().includes('.') ? price.toString().replace('.',',') : price.toString();
      }
      if (!price.includes(',')) {
        price = price + ',00';
      }
      else {
        if (price.endsWith(',')) {
          price = price + '00';
        }
        else if (price.split(',')[1].length < 2) {
          price = price + '0';
        }
      }

      const numberOfDigits = price.split(',')[0].length;

      if (!price.includes('.') && numberOfDigits > 3) {
          price = price.substring(0,numberOfDigits - 3) + "." + price.substring(numberOfDigits - 3);
          if (numberOfDigits > 6 ) {
            price = price.substring(0, numberOfDigits - 6) + "." + price.substring(numberOfDigits - 6);
          }
      }
      return price;
    }
    else return '';
  }

  //Function fills in date fields with data from backend (Plan proizvodnje)
  fillInDates(dates: any, data: any): Array<any> {
    for (let date of dates) {
      if (data?.length > 0) {
        let tmpDate;
        let tmpShift;

        tmpDate = data.find(day => day.date === date.date);

        if (tmpDate) {
          date.partialDeliveryComment = tmpDate.partialDeliveryComment || null;
          date.partialDeliveryDeadline = tmpDate.partialDeliveryDeadline || false;
          date.partialDeliveryQuantity = tmpDate.partialDeliveryQuantity || 0;

          for (let shift of date.shifts) {
            tmpShift = tmpDate.shifts.find(el => el.shiftNumber === shift.shiftNumber);

            if (tmpShift) {
              shift.quantityFinished = tmpShift.quantityFinished;
              shift.quantityPlanned = tmpShift.quantityPlanned;
              shift.shiftNumber = tmpShift.shiftNumber;
              shift.timeConsumedEmployee = tmpShift.timeConsumedEmployee;
              shift.timePlannedEmployee = tmpShift.timePlannedEmployee;
              shift.timePlannedMachine = tmpShift.timePlannedMachine;
            }
          }
        }
      }
    }
    return dates;
  }

  getMonth(month: string): string {
    let monthNumber;
    switch(month) {
      case 'Januar':
        monthNumber = '01';
        break;
      case 'Februar':
        monthNumber = '02';
        break;
      case 'Mart': 
        monthNumber = '03';
        break;
      case 'April':
        monthNumber = '04';
        break;
      case 'Maj':
        monthNumber = '05';
        break;
      case 'Jun':
        monthNumber = '06';
        break;
      case 'Jul':
        monthNumber = '07';
        break;
      case 'Avgust':
        monthNumber = '08';
        break;
      case 'Septembar':
        monthNumber = '09';
        break;
      case 'Oktobar':
        monthNumber = '10';
        break;
      case 'Novembar':
        monthNumber = '11';
        break;
      case 'Decembar':
        monthNumber = '12';
        break;
    }
    return monthNumber;
  }

  addOneDay(date: any): string {
    return date.setTime(date.getTime() + (12*60*60*1000));
  }

  // showDecimals(price: number): number {
  //   const priceString = price.toString();

  //   const afterDot = priceString.split('.')[1];

  //   if (!afterDot) {
  //     return price;
  //   }
  //   if (afterDot.startsWith('00000')) {
  //     // round to 6 decimal places
  //     return Math.floor(price * 1000000) / 1000000;
  //   } else if (afterDot.startsWith('0000')) {
  //     // round to 5 decimal places
  //     return Math.floor(price * 100000) / 100000;
  //   } else if (afterDot.startsWith('000')) {
  //     // round to 4 decimal places
  //     return Math.floor(price * 10000) / 10000;
  //   } else if (afterDot.startsWith('00')) {
  //     // round to 3 decimal places
  //     return Math.floor(price * 1000) / 1000;
  //     // round to 2 decimal places
  //   } else {
  //     return Math.floor(price * 100) / 100;
  //   }
  // }

  downloadFile(res: any, title: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = title;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  // Download all files in the zip directory
  // downloadFiles(res: any): void {
  //   const url = window.URL.createObjectURL(res);
  //   const a = document.createElement('a');
  //   document.body.appendChild(a);
  //   a.setAttribute('style', 'display: none');
  //   a.href = url;
  //   a.download = url;
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  //   a.remove();
  // }

  // Get local time from date
  getTime(date: string): string {
    return new Date(date).toLocaleTimeString();
  }
}
